import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { FileRepository } from "../../shared/domain/FileRepository";


export class CreateDocumentsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly file_repo: FileRepository,
    private readonly frontend
  ) {}

  async run(files, doc_type, company_id, user_id, folder_uuid=null): Promise<any> {
    let files_path = []
    let invalid_ext = []

    for (let i in files) {
        this.frontend.uploaded_files[files[i].name] = false;
    }

    this.frontend.uploading = true
    for (let i = 0; i < files.length; i++) {
        const ext = files[i].name.split('.').pop()
        if(!this.frontend.isValidExtension(ext)){
            invalid_ext.push(files[i].name)
        }
    }
    if(invalid_ext.length==0) {
        try {
            for (let i = 0; i < files.length; i++) {
                let ret = await this.file_repo.uploadFile(files[i])
                files_path.push({
                    "type": doc_type,
                    "path": ret,
                    "file_name": files[i].name,
                    "folder_uuid": folder_uuid
                })
                this.frontend.uploaded_files[this.frontend.uploading_file] = true;
            }

            let args = {
                user_id: user_id,
                company_id: company_id,
                info: files_path ,
                workflow_template_id: this.frontend.workflow
            }
            await this.dispatcher.dispatch('create.documents', args)

            this.frontend.uploading_file = '';
            this.frontend.uploaded_files = {};

            this.frontend.setSnackbar('success', 'Fichero(s) procesado(s) correctamente');
            files = null;
            this.frontend.uploading = false;

        } catch (error) {
            console.error('Error while upload document to s3 and command', error);
            this.frontend.error_dialog = true;
            this.frontend.error_uploading = true;
            this.frontend.uploading = false;
        }
    } else {
        this.frontend.error_dialog_ext = true;
        this.frontend.uploading = false
    }

    return files
  }
}